let CodeMirror = window.CodeMirror;

let Javascripter = $.klass({
	supportedTypes: [
		'section-separator',
		'text-response',
		'boolean-choice',
		'single-choice',
		'dropdown-choice',
		'multiple-choice',
		'text-response-grid',
		'single-choice-grid',
		'dropdown-grid',
		'datetime',
		'hidden-field',
		'custom-grid',
		'slider',
		'multiple-choice-grid',
		'drill-down',
		'threed-grid',
		'likert',
		'file-field',
		'net-promoter',
		'timer'
	],

	initialize: function(survey, editor) {
		var that = this;
		this.survey = survey;
		this.editor = editor;

		this.default_script = '$(function(){\n//place script here\n\n\n});';

		this.script = {}

		this.element = $('<form id="scriptform" method="" action="#" style=""/>').addClass('form-dialog javascripter_div');
		
		$('<div>', {'class': 'codeMirrorToolBar'}).append(
			$('<label />', {'text':gettext("Script:")}),
			$('<textarea></textarea>', {'class':'script_area', 'name':'script', 'style':'width:500px;height:150px'}),
			$('<a></a>', {'class': 'clean-button undo', 'alt': 'Undo', 'title': 'Undo'}),
			$('<a></a>', {'class': 'clean-button redo', 'alt': 'Redo', 'title': 'Redo'}),
			$('<a></a>', {'class': 'clean-button clear', 'alt': 'Clear', 'title': 'Clear'})
		).appendTo(this.element);


		$('.undo', this.element).click(function() {
			that.scriptEditor.undo();
		});

		$('.redo', this.element).click(function() {
			that.scriptEditor.redo();
		});

		$('.full-screen', this.element).click(function() {
			that.open_dialog();
		});

		$('.builder', this.element).click(function() {
			that.javascript_builder();
		});

		$('.clear', this.element).click(function() {
			that.scriptEditor.setValue(that.default_script);
		});

		$(this.element).bind('submit', function(e) {	// prevent default on the form
			e.preventDefault();
		});
	},

	javascript_builder: function() {
		var that = this;
		if(this.builder_dialog) {
			this.builder_dialog.dialog('destroy');
			this.builder_dialog = null;
			return;
		}
		if (!this.builder) {
			this.builder = $('<form id="buildform" method="" action="#" style="width:385px"/>').addClass('form-dialog javabuilder_div');
			this.questions = $('<select>');
			this.options = $('<select>');
			$('<div>', {'style':'margin-bottom:20px'}).append(
				$('<label />', {'text': gettext("Question") + ': '}),
				this.questions,
				$('<a></a>', {'href':'#', 'style':'margin-left:5px;', 'class':'help', 'text':'(?)', 'title': gettext('Question - Select a question that you would like to build JavaScript for.')}),
				$('<br /><br />'),
				$('<label />', {'text': gettext("Option") + ': ', 'style':'margin-left:14px;'}),
				this.options,
				$('<a></a>', {'href':'#', 'style':'margin-left:5px;', 'class':'help', 'text':'(?)', 'title': gettext('Option - Select an option to build the associated JavaScript.')}),
				$('<br />')
			).appendTo(this.builder);

			$('<div>', {'class': 'codeMirrorToolBar', 'style': 'width:355px'}).append(
				$('<label />', {'text':gettext("Script:")}),
				$('<textarea></textarea>', {'class':'build_area', 'name':'build', 'style':'width:380px;height:250px'})
			).appendTo(this.builder);
		}	

		this.update_builder_questions();
		$(this.questions).change(function(){
			that.update_builder_options($(that.questions).val());
		});

		if (this.dialog) {
			if ($('#buildform', this.dialog).length>0) {
				$('h3', this.dialog).remove();
				$('.scriptinsert', this.dialog).remove();
				$('#buildform', this.dialog).remove();
				$(this.dialog).parents('.ui-dialog').css('width', 930);
				$('#scriptform', this.dialog).css('margin-right', '0px');
				$('#scriptform', this.dialog).css('float', '');
				$(this.builder).css('float', '');
				$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 7px')
				$('#scriptform', this.dialog).css('width', '100%');
				$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left'))+210);
			} else {
				$(this.dialog).parents('.ui-dialog').css('width', 1350);
				$('#scriptform', this.dialog).css('margin-right', '20px');
				$('#scriptform', this.dialog).css('float', 'left');
				$('#scriptform', this.dialog).css('width', '900px');
				$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left'))-210);
				$('.codeMirrorToolBar', this.builder).append($('<a></a>', {'class': 'clean-button scriptinsert', 'style': 'float:right', 'text': gettext('Insert')}));
				$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 29px');
				$(this.builder).css('float', 'right');
				$(this.builder).prepend($('<h3>JavaScript Builder</h3>'));
				$(this.dialog).append(this.builder);
				$('.scriptinsert', this.builder).click(function(e) {
					e.preventDefault();
					that.scriptEditor.replaceSelection(that.buildEditor.getValue());
				});
			}
		} else {
			this.builder_dialog = $('<div/>').dialog({
				title: gettext('JavaScript Builder'),
				dialogClass: DIALOG_CLASS,
				width: 405,
				height: 465,
				position: [$('.pages').offset().left + $('.pages').width() + 45,'center'],
				modal: false,
				resizable: false,
				zIndex : 1020,
				close: function(){
					$(this).dialog('destroy');
					that.builder_dialog = null;
				}
			}).dialog('option','buttons',[{
				'class':'icon icon-down',
				text:gettext('Insert'),
				click:function(e) {
					that.scriptEditor.replaceSelection(that.buildEditor.getValue());
				}
			},{
				'class':'icon icon-cancel',
				text:gettext('Cancel'),
				click:function(e) {
					$(this).dialog('destroy');
					that.builder_dialog = null;
				}
			}]);

			this.builder_dialog.append(this.builder);
		}

		if (!this.buildEditor) {
			this.buildEditor = CodeMirror.fromTextArea($('.build_area', this.builder)[0], {
				theme:'monokai',
				mode: 'javascript',
				lineNumbers: false,
				smartIndent: false
			});
			this.buildEditor.setSize(null, 214);
		}
	},

	update_builder_questions: function() {
		var that = this;
		$(this.questions).empty();
		$(this.questions).append($('<option><\/option>')
			.val(null)
			.append('---'));
		$(this.questions).append($('<option><\/option>')
			.val('general')
			.append('General'));

		$(this.options).empty();
		$(this.options).append($('<option><\/option>')
			.val('')
			.append('---'));

		$.each(this.editor.survey.nameMapping, function(name, field) {	
			if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
				return;
			} else {
				$(that.questions).append($('<option><\/option>')
					.val(name)
					.append(field.name.get()));
			}
		});
	},

	update_builder_options: function(question) {
		var that = this;
		this.buildEditor.setValue('');
		$(this.options).empty();
		$(this.options).unbind();
		$(this.options).append($('<option><\/option>')
			.val('')
			.append('---'));

		if (question != '') {
			if (question == 'general') {
				$(this.options).append($('<option><\/option>')
					.val("$('title').text('INSERT TEXT HERE');\n")
					.append(gettext('Change Webpage Title')));
				$(this.options).append($('<option><\/option>')
					.val("$('.survey-title').text('INSERT TEXT HERE');\n")
					.append(gettext('Change Survey Title')));
				$(this.options).append($('<option><\/option>')
					.val("$('input[name=next]').val('INSERT TEXT HERE');\n")
					.append(gettext('Change Text of Next Button')));
				$(this.options).append($('<option><\/option>')
					.val("$('input[name=back]').val('INSERT TEXT HERE');\n")
					.append(gettext('Change Text of Back Button')));
				$(this.options).append($('<option><\/option>')
					.val("$('input[name=submitbutton]').val('INSERT TEXT HERE');\n")
					.append(gettext('Change Text of Submit Button')));
				$(this.options).append($('<option><\/option>')
					.val("chide.ui.Tooltip.init($('span[class=tool]'));\n")
					.append(gettext('Convert Tooltip HTML')));
			} else {
				$(this.options).append($('<option><\/option>')
					.val("$('.question-title', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n")
					.append(gettext('Modify Question Title')));
				if (this.editor.survey.nameMapping[question].type == 'section-separator') {

				} else if (this.editor.survey.nameMapping[question].type == 'boolean-choice') {
					$(this.options).append($('<option><\/option>')
						.val("$('li:first', '#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.appendTo('#id_" + this.editor.survey.nameMapping[question].id + "');\n")
						.append(gettext('Swap Yes and No Position')));
				} else if (this.editor.survey.nameMapping[question].type == 'text-response') {
					$(this.options).append($('<option><\/option>')
						.val("$('#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Box')));
					$(this.options).append($('<option><\/option>')
						.val("$('#id_" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Box')));
				} else if (this.editor.survey.nameMapping[question].type == 'multiple-choice') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Choice')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Each Choice')));
				} else if (this.editor.survey.nameMapping[question].type == 'single-choice') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('ul', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Choices')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Choice')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Each Choice')));
				} else if (this.editor.survey.nameMapping[question].type == 'dropdown-choice') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Drop Down')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Drop Down')));
				} else if (this.editor.survey.nameMapping[question].type == 'datetime') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Date/Time')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Date/Time')));
					$(this.options).append($('<option><\/option>')
						.val("$('tr', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend($('<td>', {'text': 'INSERT TEXT HERE', 'style': 'vertical-align:top;padding-top:9px;'}));\n")
						.append(gettext('Insert Text Before Date/Time')));
					$(this.options).append($('<option><\/option>')
						.val("$('tr', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append($('<td>', {'text': 'INSERT TEXT HERE', 'style': 'vertical-align:top;padding:9px 0 0 85px;'}));\n")
						.append(gettext('Insert Text After Date/Time')));
					$(this.options).append($('<option><\/option>')
						.val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "').each(function(i,e){\n\tif($(e).text() == '@'){\n\t\t$(e).text('INSERT TEXT HERE');\n\t}\n});\n")
						.append(gettext('Insert Text Between Date/Time')));
				} else if (this.editor.survey.nameMapping[question].type == 'text-response-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly Before Each Box')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly After Each Box')));
				} else if (this.editor.survey.nameMapping[question].type == 'single-choice-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('th:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n")
						.append(gettext('Add Top Left Label')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.prepend($('<div>', {'text': 'INSERT TEXT HERE'}));\n")
						.append(gettext('Insert Text Above Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.append($('<div>', {'text': 'INSERT TEXT HERE'}));\n")
						.append(gettext('Insert Text Below Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Radio Button')));
				} else if (this.editor.survey.nameMapping[question].type == 'dropdown-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>')
						.val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly Before Each Drop Down')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly After Each Drop Down')));
				} else if (this.editor.survey.nameMapping[question].type == 'slider') {
					$(this.options).append($('<option><\/option>')
						.val("$('.slider_question', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.css('background','blue');\n")
						.append(gettext('Change Slider Bar Colour')));
					$(this.options).append($('<option><\/option>')
						.val("$('a', $('.slider_question', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.css('background','black');\n")
						.append(gettext('Change Slider Bar Colour')));
				} else if (this.editor.survey.nameMapping[question].type == 'multiple-choice-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('th:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.html('INSERT TEXT HERE');\n")
						.append(gettext('Add Top Left Label')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.prepend($('<div>', {'text': 'INSERT TEXT HERE'}));\n")
						.append(gettext('Insert Text Above Checkbox')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "').parent()\n\t.append($('<div>', {'text': 'INSERT TEXT HERE'}));\n")
						.append(gettext('Insert Text Below Checkbox')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Checkbox')));
					$(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Checkbox')));
				} else if (this.editor.survey.nameMapping[question].type == 'custom-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('li.variable', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Variable Name')));
					$(this.options).append($('<option><\/option>')
						.val("$(':first', $('.variable', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly Before Each Input')));
					$(this.options).append($('<option><\/option>')
						.val("$('li.variable', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Directly After Each Input')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', $('.variable ul', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Each Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', $('.variable ul', $('#x" + this.editor.survey.nameMapping[question].id + "')))\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Each Radio Button')));
				} else if (this.editor.survey.nameMapping[question].type == 'drill-down') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Selection')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Selection')));
					$(this.options).append($('<option><\/option>')
						.val("$('.drill-down-selector', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.css('background','yellow');\n")
						.append(gettext('Change Box Background Colour')));
					$(this.options).append($('<option><\/option>')
						.val("$('.drill-down-selector:first', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Between Boxes')));
				} else if (this.editor.survey.nameMapping[question].type == 'threed-grid') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Every Input')));
					$(this.options).append($('<option><\/option>')
						.val("$('td', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Every Input')));
					$(this.options).append($('<option><\/option>')
						.val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Drop Down')));
					$(this.options).append($('<option><\/option>')
						.val("$('select', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Drop Down')));
					$(this.options).append($('<option><\/option>')
						.val("$(':text', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Textbox')));
					$(this.options).append($('<option><\/option>')
						.val("$(':text', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Textbox')));
					$(this.options).append($('<option><\/option>')
						.val("$(':checkbox', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.before('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Checkbox')));
					$(this.options).append($('<option><\/option>')
						.val("$(':checkbox', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.after('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Checkbox')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('li', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Radio Button')));
					$(this.options).append($('<option><\/option>')
						.val("$('tr', $('tbody', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.before($('<tr>')\n\t\t.append($('<td>', {'text': 'INSERT TEXT HERE', 'colspan':'" + (this.editor.survey.nameMapping[question].columns.value.length+1) + "', 'style': 'background:LightGray'})));\n")
						.append(gettext('Insert Row Separators')));
				} else if (this.editor.survey.nameMapping[question].type == 'likert') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
				} else if (this.editor.survey.nameMapping[question].type == 'file-field') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before File Field')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After File Field')));
				} else if (this.editor.survey.nameMapping[question].type == 'net-promoter') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Above Grid')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Below Grid')));
				} else if (this.editor.survey.nameMapping[question].type == 'hidden-field') {
					(this.options).append($('<option><\/option>')
						.val("$('input', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.val('INSERT VALUE HERE');\n")
						.append(gettext('Set Value of Hidden Field')));
				} else if (this.editor.survey.nameMapping[question].type == 'timer') {
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.prepend('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text Before Start Button/Link')));
					$(this.options).append($('<option><\/option>')
						.val("$('.question-body', '#x" + this.editor.survey.nameMapping[question].id + "')\n\t.append('INSERT TEXT HERE');\n")
						.append(gettext('Insert Text After Start Button/Link')));
					(this.options).append($('<option><\/option>')
						.val("$('span', $('a', '#x" + this.editor.survey.nameMapping[question].id + "'))\n\t.html('INSERT TEXT HERE');\n")
						.append(gettext('Change Text of Start Button/Link')));
				}
			}
		}
		$(this.options).change(function(){
			that.buildEditor.setValue($(that.options).val());
		});
	},

	open_dialog: function() {
		var that = this;

		this.parent_element = this.element.parent();

		this.dialog = $('<div/>')
			.append(this.element)
			.dialog({
				title: gettext('JavaScript Editor'),
				dialogClass: DIALOG_CLASS,
				width: 930,
				height: 475,
				modal: true,
				resizable: false,
				close: function(){
					if ($('#buildform', that.dialog).length>0) {
						$('h3', that.dialog).remove();
						$('.scriptinsert', that.dialog).remove();
						$('#scriptform', that.dialog).css('width', '100%');
						$(that.builder).css('float', '');
						$('.codeMirrorToolBar', that.builder).css('padding', '3px 7px 7px');
						that.javascript_builder();
					}
					$('.full-screen', that.element).show();
					that.parent_element.append(that.element);
					$(this).dialog('destroy');
					that.dialog = null;
				}
			});

		$('.full-screen', this.element).hide();
		if (this.builder_dialog) {
			$(this.builder_dialog).dialog('destroy');
			this.builder_dialog = null;
			$(this.dialog).parents('.ui-dialog').css('width', 1350);
			$('#scriptform', this.dialog).css('margin-right', '20px');
			$('#scriptform', this.dialog).css('float', 'left');
			$('#scriptform', this.dialog).css('width', '900px');
			$(this.dialog).parents('.ui-dialog').css('left', parseInt($(this.dialog).parents('.ui-dialog').css('left'))-210)
			$('.codeMirrorToolBar', this.builder).append($('<a></a>', {'class': 'clean-button scriptinsert', 'style': 'float:right', 'text': gettext('Insert')}));
			$('.codeMirrorToolBar', this.builder).css('padding', '3px 7px 29px');
			$(this.builder).css('float', 'right');
			$(this.builder).prepend($('<h3>JavaScript Builder</h3>'));
			$(this.dialog).append(this.builder);
			$('.scriptinsert', this.builder).click(function(e) {
				e.preventDefault();
				that.scriptEditor.replaceSelection(that.buildEditor.getValue());
			});
		}
	},

	update_piper: function(survey, limit_to_page, noids) {
		var that=this;
		this.limit_to_page = limit_to_page;
		this.noids = noids;
		this.survey._formatInfo = null;
		this.survey = survey;
		this.currentPage = 0;//Fields.Helpers.getPageIndexByPageId(that.survey.currentPage.id);
		$(that.piper).empty();
		if(!that.limit_to_page) {
			if (!that.noids) {
				$(that.piper).append($('<option/>', {value: '', html: gettext('Please select a question or variable...')}));
				this.idGroup = $('<optgroup/>', {
					label: gettext('Question IDs')
				}).appendTo(this.piper);

				var selector = chide.fs.Utils.buildSourceDropdown(
					this.survey.formatInfo(), 
					{
						'showEmpty': true,
						'varPred': true,
						'questionPred': true,
						'pagePred': function(page) { return page.index == that.currentPage; },
						'showRowsAndColumns': true,
						'show3DVariables': true,
						'showMetas': false,
						'forceIndent': true
					});
				$(this.piper).append($(selector).children()[1]);
				$(this.piper)[0].selectedIndex = 0;
			} else {
				$(that.piper).append($('<option/>', {value: '', html: gettext('Please select a question or variable...')}));
			}
			this.pipedGroup = $('<optgroup/>', {
				label: gettext('Piped Variables')
			}).appendTo(this.piper);

			$.each(this.editor.survey.nameMapping, function(name, field) {	
				j=0;
				if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
					return;
				} else if (field.page.index == that.currentPage) {
					return;
				} else {
					if (field.isGrouped && field.type != 'drill-down' && field.type != 'net-promoter') {
						_.each(field.variables.value, function(el, i) {
							that.pipedGroup.append($('<option><\/option>')
								.val("{{ "+name + '.' + (j++) + " }}")
								.append(field.name.get() + " :: " +field.variables.getAt(i) + ' Answer'));
						});
					} else {
						that.pipedGroup.append($('<option><\/option>')
							.val("{{ " + name + " }}")
							.append(field.name.get() + ' Answer'));
					}
				} 
			});

			this.inviteGroup = $('<optgroup/>', {
				label: gettext('Invite Variables')
			}).appendTo(this.piper);

			this.inviteGroup.append(
				$('<option>', {'val':'{{ invite.first_name }}', 'text': gettext("Invite: First Name")}),
				$('<option>', {'val':'{{ invite.last_name }}', 'text': gettext("Invite: Last Name")}),	
				$('<option>', {'val':'{{ invite.full_name }}', 'text': gettext("Invite: Full Name")}),	
				$('<option>', {'val':'{{ invite.email }}', 'text': gettext("Invite: E-Mail Address")}),
				$('<option>', {'val':'{{ invite.code }}', 'text': gettext("Invite: Code")})
			);

			this.miscGroup = $('<optgroup/>', {
				label: gettext('Miscellaneous')
			}).appendTo(this.piper);

			this.miscGroup.append(
				$('<option>', {'val':"$('html').attr('lang')", 'text': gettext("Current Survey Language")})
			);
		} else {
			$(that.piper).append($('<option/>', {value: '', html: gettext('Please select a question or variable...')}));

			if (!that.noids) {
				this.idGroup = $('<optgroup/>', {
					label: gettext('Question IDs')
				}).appendTo(this.piper);
			}

			this.pipedGroup = $('<optgroup/>', {
				label: gettext('Piped Variables')
			}).appendTo(this.piper);

			$.each(this.editor.survey.nameMapping, function(name, field) {	
				var j = 0;
				if (field.page.index > that.currentPage || that.supportedTypes.indexOf(field.type) == -1) {
					return;
				} else if (field.page.index == that.currentPage) {
					if (!that.noids) {
						that.idGroup.append($('<option><\/option>')
							.val(field.id)
							.append(field.name.get() + " ID"));
					} else {
						return;
					}
				} else {
					if (field.isGrouped && field.type != 'drill-down' && field.type != 'net-promoter') {
						_.each(field.variables.value, function(el, i) {
							that.pipedGroup.append($('<option><\/option>')
								.val("{{ "+name + '.' + (j++) + " }}")
								.append(field.name.get() + " :: " +field.variables.getAt(i) + ' Answer'));
						});
					} else {
						that.pipedGroup.append($('<option><\/option>')
							.val("{{ " + name + " }}")
							.append(field.name.get() + ' Answer'));
					}
				} 
			});
			this.inviteGroup = $('<optgroup/>', {
				label: gettext('Invite Variables')
			}).appendTo(this.piper);

			this.inviteGroup.append(
				$('<option>', {'val':'{{ invite.first_name }}', 'text': gettext("Invite: First Name")}),
				$('<option>', {'val':'{{ invite.last_name }}', 'text': gettext("Invite: Last Name")}),	
				$('<option>', {'val':'{{ invite.full_name }}', 'text': gettext("Invite: Full Name")}),	
				$('<option>', {'val':'{{ invite.email }}', 'text': gettext("Invite: E-Mail Address")}),
				$('<option>', {'val':'{{ invite.code }}', 'text': gettext("Invite: Code")})
			);
			this.miscGroup = $('<optgroup/>', {
				label: gettext('Miscellaneous')
			}).appendTo(this.piper);

			this.miscGroup.append(
				$('<option>', {'val':"$('html').attr('lang')", 'text': gettext("Current Survey Language")})
			);
		}
	},

	set: function(scriptsettings) {
		var that = this;
		try {
			this.script = scriptsettings['field'].description['value'].replace('<script type="text/javascript">\n', '').replace('<script>\n', '').replace('<script type="text/javascript">', '').replace('<script>', '').replace('</script>', '');
		} catch(e) {
			this.script = this.default_script;
		}
		if (this.scriptEditor) {
			this.scriptEditor.toTextArea();
		}
		this.scriptEditor = CodeMirror.fromTextArea($('.script_area', scriptsettings['field'].element)[0], {
			theme: 'monokai',
			mode: 'javascript',
			lineNumbers: true,
			smartIndent: false,
		});

		this.scriptEditor.on('change', function(editor) {
			var temp = editor.getValue();
			temp = temp.replace('<script type="text/javascript">\n', '')
				.replace('<script>\n', '')
				.replace('<script type="text/javascript">', '')
				.replace('<script>', '')
				.replace('</script>', '');
			scriptsettings['field'].description.set(temp);
		});
		this.scriptEditor.setValue(this.script);
		this.scriptEditor.clearHistory();

		this.update_piper(this.survey, scriptsettings['globalpiper'], scriptsettings['noids']);
	},

	serialize: function() {
		var that = this;
		var result = {};

		return result;
	}
});

module.exports = Javascripter;
